import type { Comment } from '@/@types/comment'
import CommentThread from '@/components/Comment/CommentThread'
import { type GetCommentParams, getCommentQueryOptions } from '@/utils/fetchers/comment'
import { useSuspenseQuery } from '@tanstack/react-query'
import type { MouseEvent } from 'react'
import StoryCommentActions from './StoryCommentActions'

export interface StoryCommentProps {
	canReply: boolean
	data: GetCommentParams
	onDelete: (data: Comment) => Promise<Comment>
	onReply: (data: Comment) => void
	showReplies?: boolean
}

export default function StoryComment({
	canReply,
	data: commentQueryParams,
	onDelete,
	onReply,
	showReplies = true,
}: StoryCommentProps) {
	const { data } = useSuspenseQuery(getCommentQueryOptions(commentQueryParams))

	const handleClick = (event: MouseEvent<HTMLDivElement>) => {
		if (!canReply || window.getSelection()?.toString().length) return

		event.stopPropagation()
		onReply(data)
	}
	const renderReply = (replyData: GetCommentParams) => (
		<StoryComment
			canReply={canReply}
			data={replyData}
			onDelete={onDelete}
			onReply={onReply}
			showReplies={false}
		/>
	)

	return (
		<CommentThread
			actions={
				<StoryCommentActions
					canReply={canReply}
					data={data}
					onDelete={onDelete}
					onReply={onReply}
				/>
			}
			clickable={canReply}
			data={data}
			onClick={handleClick}
			renderReply={showReplies ? renderReply : undefined}
		/>
	)
}
